<div id="document-id">

   <div class="mobile-view-only" style="text-align:center;">
      <header class="header-center-panal" style="text-align:center">
         <h3 style="font-size: 15px;">Select Documents</h3>
      </header>
      <hr>
      <p class="sub-header-left-panal" style="text-align:center;font-size: 12px;">Select documents and
         confirm amounts for payment
      </p>
   </div>
   <div id="header">
      <div class="mobile-header-left header-left">
         <dl>
            <dd>
               <h3 style="font-size: 25px;"><b>{{customerInfo?.customerName}}</b></h3>
            </dd>
            <dd style="font-size: 14px;margin-top: -25px;">Account: <b>{{customerInfo?.customerAccountNumber}}</b></dd>
            <dd style="font-size: 12px;" class="web-view-only web-total-document-count">Total Documents:
               {{invoiceValues?.length}} </dd>
            <dd style="font-size: 12px;" class="web-view-only web-total-balance">Total Balance:
               {{formatNumber(TotalDocumentAmount)}}</dd>
         </dl>
         <!-- <div class="mobile-view-only">
            <label for="dateFin" class="mob-payment-date">Payment Date</label>
            <p-calendar ngDefaultControl [(ngModel)]="payment_date" [minDate]="minDate" dateFormat="dd/mm/yy"
               inputStyleClass="form-control payment-date-size" placeholder="Choose a date" [showIcon]="true"
               class="mobile-device-payment-date">
            </p-calendar>
         </div> -->
         <span class="md-inputfield calender-width-mobile mobile-view-only">
            <label for="dateFin">Payment Date</label>
            <p-calendar appendTo="body" ngDefaultControl [(ngModel)]="payment_date" [minDate]="minDate"
               dateFormat="mm/dd/yy"  placeholder="Choose a date"
               [showIcon]="true" class="mobile-device-payment-date">
            </p-calendar>
         </span>

      </div>
      <div id="header-right">
         <div *ngIf="errorValidation">
            <aur-notice severity="error">
               {{ValidationMessage}}
            </aur-notice>
         </div>
      </div>
   </div>
   <br>
   <div id="selecteds">
      <div style="width: 5em" class="mobile-selectView"><span style="font-size: 12px;" (click)="onClick()"> Select
            All</span> </div>
      <div class="mobile-selecteds-right selecteds-right" *ngIf="selectedRows?.length > 0 ">
         <aur-tag class=" web-view-only selecteds-right-count aur-tag-info" (remove)="onremove()">
            {{selectedRows?.length}} documents selected
         </aur-tag>
         <span class="mobile-view-only mobile-selecteds-right-count mobile-count-info">Selected {{selectedRows?.length}}
            of {{invoiceValues?.length}}
         </span>
      </div>
   </div>
   <p-table #table [autoLayout]="true" [columns]="cols" [value]="invoiceValues" dataKey="documentId"
      (onPage)="onPage($event)" (onRowExpand)="onRowExpand()" (onRowCollapse)="onRowCollapse()"
      [expandedRowKeys]="expandedRows" selectionMode="multiple" [responsive]="true" styleClass="document-ptable"
      [(selection)]="selectedRows">
      <ng-template pTemplate="header" let-columns>
         <tr>
            <th class="td-width-3">
               <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <th class="front-tableCheckbox table td-width-4"></th>
            <th [ngClass]="shortPayHeader ? 'header-td-extand-width' : 'header-td-reduce-width'"><span>Document</span>
            </th>
            <th [ngClass]="shortPayHeader ? 'header-td-extand-width' : 'header-td-reduce-width'"><span>Dates</span></th>
            <th [ngClass]="shortPayHeader ? 'header-td-extand-width' : 'header-td-reduce-width'"><span>Amounts</span>
            </th>
            <th [ngClass]="shortPayHeader ? 'header-td-extand-width text-call' : 'header-td-reduce-width text-call'">
               <span>Paid Online</span>
            </th>
            <th [ngClass]="shortPayHeader ? 'header-td-extand-width' : 'header-td-reduce-width'"><span>Pay Amount</span>
            </th>

            <th *ngIf="shortPayHeader"
               [ngClass]="shortPayHeader ? 'header-td-extand-width-1 text-align-reason' : 'header-td-reduce-width-1 text-align-reason'">
               <span>Reason</span>
            </th>
            <th class="mobile-view-tableCheckbox table td-width-4 mobile-view-only"></th>
         </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-col let-expanded="expanded" let-columns="columns"
         let-rowIndex="rowIndex" style="margin-top: -12px;">
         <tr>
            <td class="td-width-3">
               <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
            </td>
            <td class="web-view-only table td-width-4">
               <a href="#" [pRowToggler]="rowData">
                  <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
               </a>
            </td>
            <td class="test_documt" [ngClass]="shortPayHeader ? 'body-td-extand-width' : 'body-td-reduce-width'">
               <div class="mobile-doc mobile-view-only text-align-left">Document</div>
               <div class="mobile-device-class common-class">
                  <span>{{ col.documentTypeName }}</span><br>
                  <span class="td-span-size"> {{col.invoiceNumber}}</span>
               </div>
            </td>

            <td [ngClass]="shortPayHeader ? 'body-td-extand-width' : 'body-td-reduce-width'">
               <div class="mobile-doc mobile-view-only text-align-left">Due Date</div>
               <div class="common-class mobile-device-class">
                  <span class="web-view-only">Due Date<br></span>
                  <span class="td-span-size"> {{checkDateFormate(col.dueDate)}} </span>
               </div>
            </td>

            <td [ngClass]="shortPayHeader ? 'body-td-extand-width' : 'body-td-reduce-width'">
               <div class="mobile-doc mobile-view-only text-align-left">Open Balance</div>
               <div class="common-class mobile-device-class">
                  <span class="web-view-only">Open Balance<br></span>
                  <span class="td-span-size"> {{formatNumber(col.openBalance)}} </span>
               </div>
            </td>

            <td [ngClass]="shortPayHeader ? 'body-td-extand-width text-call' : 'body-td-reduce-width text-call'"
               class="web-view-only paid-amount ">
               <span class="span-font-size span-color text-align-left">{{col.label}} </span>
               <span class="td-span-size"> {{formatNumber(col.paidOnline)}}</span>
            </td>
            
            <td [ngClass]="shortPayHeader ? 'body-td-extand-width ' : 'body-td-reduce-width '" style="width:20%;">
               <div class="mobile-doc mobile-view-only text-align-left">Pay Amount</div>
               <div class="common-class mobile-device-class">
                  <div class="p-inputgroup">
                     <span class="td-span-size">$</span>
                     <input pInputText placeholder="Pay Amount"
                        (blur)="onBlurMethod($event,col.actualAmount,col.itemType,col.openBalance)"
                        (change)="onChange($event,col.actualAmount,col.itemType,col.openBalance)"
                        value="{{FormatNumberwoCurrency(col.payAmount)}}" id="{{rowIndex}}" [disabled]='overNshortPay'
                        class="payamount input-text-align" autocomplete="off" appTwoDigitDecimaNumber>
                  </div>
                  <input type="hidden" value="{{(col.showPay)}}">
               </div>
            </td>

            <td *ngIf="col.showPay" [ngClass]="shortPayHeader ? 'body-td-extand-width-1' : 'body-td-reduce-width-1'">
               <div class="mobile-doc mobile-view-only text-align-left">Reason</div>
               <div class="common-class mobile-device-class ">
                  <aur-dropdown appendTo="body" placeholder="Select Reason"
                     [(ngModel)]="col.shortPayreason" class="common-class mobile-device-class {{checkboxBgClr}}"
                     [options]="shortpayTypes">
                  </aur-dropdown>

                  <div *ngIf="col.shortPayreason === 'Others'">
                     <aur-input autocomplete="off" type="text" placeholder="Enter the reasons" ngDefaultControl
                        [(ngModel)]="col.shortPayText" [style]="{'width':'90%'}" class='reason-text'> </aur-input>
                  </div>
               </div>
            </td>
            <td *ngIf="(shortPayHeader) && (!col.showPay)"> </td>
            <td class="mobile-view-only" *ngIf="!expanded">
               <a href="#" [pRowToggler]="rowData">
                  <span class="span-font-size" *ngIf="!expanded"> See More</span>
                  <i *ngIf="!expanded" class="fa fa-fw fa-chevron-circle-down icon-align"></i>
               </a>
            </td>
         </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
         <tr>
            <td [attr.colspan]="columns.length">
               No records found
            </td>
         </tr>
      </ng-template>
      <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns" let-rowIndex="rowIndex">
         <tr class="mobile-more_details-background-color other-more-details-background-color">
            <td [attr.colspan]="colLength" class="mobile-more_details-td other-more-details-td">
               <div style="width: 100%;" class="mobile-more_shortPayHide p-grid p-fluid other-more_shortPayShow'">
                  <div class="more_shortPayShow">
                     <div class="p-col-12">
                        <div class="web-view-only">
                           <div class="p-grid">
                              <div [ngClass]="shortPayHeader ? 'p-col-1 more-info-1' : 'p-col-1 more-info'">
                                 More <br>Details
                              </div>
                              <div [ngClass]="shortPayHeader ? 'p-col-2 align-line-1' : 'p-col-2 align-line'">
                                 <dl *ngIf="rowData.poNumber || rowData.jobNumber || rowData.projectNumber ">
                                    <div *ngIf="rowData.poNumber">
                                       <dt>PO Number </dt>
                                       <dd>{{rowData.poNumber}}</dd>
                                    </div>
                                    <div *ngIf="rowData.jobNumber">
                                       <dt>Job Number</dt>
                                       <dd>{{rowData.jobNumber}}</dd>
                                    </div>
                                    <div *ngIf="rowData.projectNumber">
                                       <dt>Project Number</dt>
                                       <dd>{{rowData.projectNumber}}</dd>
                                    </div>
                                 </dl>
                              </div>
                              <div [ngClass]="shortPayHeader ? 'p-col-2 align-line-1' : 'p-col-2 align-line'">
                                 <dl *ngIf="rowData.discountDate || rowData.billDate">
                                    <div *ngIf="rowData.discountDate.trim()">
                                       <dt>Discount Date</dt>
                                       <dd>{{checkDateFormate(rowData.discountDate)}}</dd>
                                    </div>
                                    <div *ngIf="rowData.billDate">
                                       <dt>Bill Date</dt>
                                       <dd>{{checkDateFormate(rowData.billDate)}}</dd>
                                       <dt></dt>
                                       <dd></dd>
                                    </div>
                                 </dl>
                              </div>
                              <div [ngClass]="shortPayHeader ? 'p-col-2 align-line-1' : 'p-col-2 align-line'">
                                 <dl *ngIf="rowData.discountAmount || rowData.totalDue">
                                    <div *ngIf="rowData.discountAmount" >
                                       <dt>Discount Amount</dt>
                                       <dd>{{ formatNumber(rowData.discountAmount) }}</dd>
                                    </div>
                                    <div *ngIf="rowData.totalDue" >
                                       <dt>Bill Amount</dt>
                                       <dd>{{ formatNumber(rowData.totalDue )}}</dd>
                                       <dt></dt>
                                       <dd></dd>
                                    </div>
                                 </dl>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div class="mobile-more-info mobile-view-only">
                        <div class="text-align-line-height">
                           <div *ngIf="rowData.poNumber">
                              <dt class="text-align-left">PO</dt>
                              <dd class="text-align-right">{{rowData.poNumber}}</dd>
                              <br>
                           </div>
                           <div *ngIf="rowData.billDate">
                              <dt class="text-align-left">Bill Date</dt>
                              <dd class="text-align-right">{{checkDateFormate(rowData.billDate)}}</dd>
                              <br>
                           </div>
                           <div *ngIf="rowData.totalDue" >
                              <dt class="text-align-left">Bill Amount</dt>
                              <dd class="text-align-right">{{ formatNumber(rowData.totalDue )}}</dd>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>

            </td>
            <td class=" mobile-view-only">
               <a href="#" [pRowToggler]="rowData">
                  <span class="span-font-size"> See Less</span>
                  <i class="fa fa-fw fa-chevron-circle-up icon-align"></i>
               </a>
            </td>

         </tr>
      </ng-template>
   </p-table>
   <br>
   <aur-grid-area class="payment-footer payment-footer-panel" *ngIf="invoiceValues?.length">
      <span class="md-inputfield full-width  web-view-only">
         <label for="dateFin">Payment Date</label>
         <p-calendar appendTo="body" ngDefaultControl [(ngModel)]="payment_date" disabled="true"
            dateFormat="mm/dd/yy" inputStyleClass="form-control payment-date-size" placeholder="Payment date"
            [showIcon]="false" class="mobile-device-payment-date">
         </p-calendar>
      </span>
      <br>
      <aur-card>
         <b>
            <div id="documentCurrenyType{{currencyVal}}">{{currencyType}}Total Amount: {{ selectedRows?.length > 0 ?
               formatNumber(selectedAmount) : '$0.00'}}</div>
         </b>
      </aur-card>
      <footer>
         <div class="text-align-right text-padding">
            <button aur-button type="submit" id="prevBtn" (click)="nextPrev(-1)" style="display: none;">Previous
               step</button>
         </div>
         <div class="text-align-right text-padding mobile-btn-view">
            <button class="mobile-btn-view" aur-button type="submit" (click)="loadPac(1)">Next: Payment Method</button>
         </div>
      </footer>
   </aur-grid-area>



   <p-dialog header="Payment Method Breakdown" [(visible)]="showFlex" [modal]="true">
      <div id="divPayWizard1" style="overflow-x: hidden;">
         <hr />
         <p><span class="cc-font">Some of the selected documents have restrictions on the Payment Method. Please review
               the below details and decide how you want to proceed.</span></p>
         <hr />
         <div id="divDocumentBreakdown">
            <div class="row-flex">
               <div class="column-flex" *ngIf="flexbileDocument['A']?.length>0">
                  <span class="text-align-left"><b>Documents to be paid via ACH</b></span>
                  <table class="table-flex">
                     <tr>
                        <th class="table-th-flex">Document&nbsp;#</th>
                        <th class="table-th-flex">Inv&nbsp;Date</th>
                        <th class="table-th-flex">Due&nbsp;Date</th>
                     </tr>
                     <tr *ngFor="let ach of flexbileDocument['A'];">
                        <td class="table-td-flex">{{ach.invoiceNumber}}</td>
                        <td class="table-td-flex"> {{ach.billDate}}</td>
                        <td class="table-td-flex">{{ach.dueDate}}</td>
                     </tr>

                  </table>
               </div>
               <div class="column-flex" *ngIf="flexbileDocument['C']?.length>0">
                  <span class="text-align-left"><b>Documents to be paid via Credit Card</b></span>
                  <table class="table-flex">

                     <tr>
                        <th class="table-th-flex">Document&nbsp;#</th>
                        <th class="table-th-flex">Inv&nbsp;Date</th>
                        <th class="table-th-flex">Due&nbsp;Date</th>
                     </tr>
                     <tr *ngFor="let cc of flexbileDocument['C'];">
                        <td class="table-td-flex">{{cc.invoiceNumber}}</td>
                        <td class="table-td-flex">{{cc.billDate}}</td>
                        <td class="table-td-flex">{{cc.dueDate}}</td>
                     </tr>

                  </table>
               </div>
            </div>

         </div>
         <br />
         <hr />
         <div id="divbottom">
            <table id='CancelNext' class='cc-wiz1Nav-table' style="float:right ;">
               <tr>

                  <td *ngIf="flexbileDocument['A']?.length>0">
                     <div class="text-align-right">
                        <button class="mobile-btn-view" aur-button type="submit" name="btnPayACH" id="btnPayACH"
                           (click)="payflexbile('ACH')">Pay with ACH</button>
                     </div>
                  </td>
                  <td *ngIf="flexbileDocument['C']?.length>0">
                     <div class="text-align-right">
                        <button class="mobile-btn-view" aur-button type="submit" name="btnPayCC" id="btnPayCC"
                           (click)="payflexbile('CC')">Pay with Credit Card</button>
                     </div>

                  </td>
               </tr>
            </table>
         </div>
      </div>
   </p-dialog>
</div>